import React, { useState } from 'react';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import HookForm from '../../../../components/HookForm/HookForm';
import {
  CAR_DOC_TYPE_PURCHASE_CONTRACT,
  CAR_DOC_TYPE_INSPECTION_ACT,
  CAR_DOC_TYPE_PHOTOS,
  CAR_DOCUMENT_TYPE_MAP
} from '../../../../constants/carDocumentTypes';

const DocumentsForm = ({ onSubmit, currentData, carId }) => {
  const [documentsForm, setDocumentsForm] = useState([
    {
      text: CAR_DOCUMENT_TYPE_MAP[CAR_DOC_TYPE_PURCHASE_CONTRACT],
      label: 'Выберите файл договора',
      name: String(CAR_DOC_TYPE_PURCHASE_CONTRACT),
      component: DocsInputNew,
      accept: '.pdf,.doc,.docx',
      hint: 'Загрузите договор в формате PDF или Word',
      rules: { required: true },
      id: CAR_DOC_TYPE_PURCHASE_CONTRACT,
      defaultValue: currentData?.[CAR_DOC_TYPE_PURCHASE_CONTRACT],
    },
    {
      text: CAR_DOCUMENT_TYPE_MAP[CAR_DOC_TYPE_INSPECTION_ACT],
      label: 'Выберите файл акта',
      name: String(CAR_DOC_TYPE_INSPECTION_ACT),
      component: DocsInputNew,
      accept: '.pdf,.doc,.docx',
      hint: 'Загрузите акт приёмки в формате PDF или Word',
      rules: { required: true },
      id: CAR_DOC_TYPE_INSPECTION_ACT,
      defaultValue: currentData?.[CAR_DOC_TYPE_INSPECTION_ACT],
    },
    {
      text: CAR_DOCUMENT_TYPE_MAP[CAR_DOC_TYPE_PHOTOS],
      label: 'Выберите файл',
      name: String(CAR_DOC_TYPE_PHOTOS),
      component: DocsInputNew,
      accept: '.pdf,.doc,.docx,.jpg,.png,.jpeg',
      hint: 'Фотографии автомобиля в формате PDF или Word',
      rules: { required: true },
      id: CAR_DOC_TYPE_PHOTOS,
      defaultValue: currentData?.[CAR_DOC_TYPE_PHOTOS],
      multiple: true,
    },
  ]);

  const handleSubmit = async (values) => {
    // Проверяем, что все обязательные документы загружены
    const requiredDocs = [
      String(CAR_DOC_TYPE_PURCHASE_CONTRACT),
      String(CAR_DOC_TYPE_INSPECTION_ACT),
      String(CAR_DOC_TYPE_PHOTOS),
    ];
    const missingDocs = requiredDocs.filter((docId) => !values[docId]);

    if (missingDocs.length > 0) {
      const missingLabels = missingDocs.map((docId) => CAR_DOCUMENT_TYPE_MAP[docId] || docId);
      alert.error(`Необходимо загрузить следующие документы: ${missingLabels.join(', ')}`);
      return;
    }

    onSubmit(values);
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        inputs={documentsForm}
        title={'Загрузка документов выкупа'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr' }}
        handlerSetState={setDocumentsForm}
        onSubmit={handleSubmit}
        action={'Сохранить'}
        border
      />
    </div>
  );
};

export default DocumentsForm;
